// GraphQL date/time formats
export const API_LOCAL_TIME_FORMAT = 'HH:mm:ss';
export const API_LOCAL_DATE_FORMAT = 'YYYY-MM-DD';
export const API_LOCAL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
/**
 * Array of all available time formats set up in moment
 * These are the common time formats used throughout the codebase
 *
 * Usage with moment:
 * ```typescript
 * const timeMoment = moment(timeString, ALL_LOCAL_TIME_FORMATS);
 * // moment will try each format until it finds a match
 * ```
 */
export const ALL_LOCAL_TIME_FORMATS = [
    'HH:mm:ss', // 24-hour format with seconds (e.g., "13:30:00")
    'HH:mm', // 24-hour format without seconds (e.g., "13:30")
    'H:mm', // 24-hour format without seconds and just single digit (e.g., "3:30")
    'h:mma', // 12-hour format (e.g. "1pm")
    'h:mm A', // 12-hour format (e.g. "1:30 PM")
    'h A', // 12-hour format without minutes (e.g. "6 AM")
    'ha', // 12-hour format without minutes or space (e.g. "6am")
];
/**
 * Takes a javascript Date and returns a string formatted to YYYY-MM-DD
 *
 * @param date - The Date to format
 * @returns ISO date string in YYYY-MM-DD format
 *
 * @example
 * formatDateToISO(new Date('2024-03-15')) // returns '2024-03-15'
 */
export const formatDateToISO = (date) => date.toISOString().slice(0, 10);
